<template>
    <!-- Same UModal scrim as checkout; mounted on the app shell so route changes do not unmount it (TK-12945). -->
    <LoadingScrimOverlay :open="scrimOpen" v-bind="scrimContent" />
</template>

<script setup lang="ts">
/**
 * App-root host for checkout / submit processing scrim (TK-12945).
 * Mount once in each app shell (`apps/capacitor/app.vue`, `apps/web/app.vue`).
 */
import LoadingScrimOverlay from './LoadingScrimOverlay.vue'
import { useHandwritingSubmitLoadingScrim } from '~~/layers/base/composables/useHandwritingSubmitLoadingScrim'

const { host } = useHandwritingSubmitLoadingScrim()
/** Top-level refs so the template unwraps booleans/props (nested host.open does not). */
const scrimOpen = host.open
const scrimContent = host.content
</script>
